import React, { useState } from 'react';
import FileDownload from './FileDownload';
import PrintFile from './PrintFile';
import MenuIcon from '../../../grid/MenuIcon';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { FileSharingClientDetailsModal } from 'components/FileSharing/FileSharingClientDetailsModal';
import SummarizeFile from './SummarizeFile';
import CreateCourtEvent from './CreateCourtEvent';
import GlobalTooltip from 'components/GlobalTooltip';
import useFileDownload from 'modules/FileManagerV2/hooks/ui/useFileDownload';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { isInsideSharedFolder } from 'utils/fileManagerSharedFolderUtils';

function ActionsTemplate({ rowData, e, itemsRef, onDownloadComplete }) {
  const { isClientFileManager, modals, setSelectedRows, fileManagerFilters } = useFileManagerContext();
  const { setShowShareFileModal } = modals;
  const { downloadCertFile } = useFileDownload();
  const { checkSubPermission } = useUserDetailsContext();
  const hideShare = isInsideSharedFolder(fileManagerFilters);

  const handleShareClick = () => {
    setShowShareFileModal(true);
    setSelectedRows([rowData]);
  };

  const docTypeVal = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  const printFileFormats = [
    'image/*',
    'application/pdf',
    // docTypeVal,
    // 'image/jpeg',
    // 'image/jpg',
    // 'image/gif',
    // 'image/bmp',
    // 'image/tiff',
    // 'image/webp',
    // 'image/heic',
    // 'image/heif',
    // 'text/plain',
    // 'text/csv',
  ];
  const fileFormatsForSummary = ['application/pdf', 'docx', 'application/msword', docTypeVal];

  const [clientDetailsModalshow, setClientDetailsModalshow] = useState(false);

  const handleDownloadCertificate = () => {
    downloadCertFile(rowData, onDownloadComplete);
  };

  return (
    <React.Fragment key={e.rowIndex}>
      <span className="p-column-title text-break">Actions</span>

      <span className="text-break relative d-flex align-items-center justify-content-end gap-3">
        {/* File-specific actions */}
        {rowData.entry_type !== 'folder' && (
          <>
            {!isClientFileManager &&
              rowData?.file_type &&
              fileFormatsForSummary.includes(rowData?.file_type?.toLowerCase()) &&
              checkSubPermission('ai_summarize') && <SummarizeFile rowData={rowData} />}

            {checkSubPermission('ai_court_setting_notice') && !isClientFileManager && rowData?.is_court_setting_notice && (
              <CreateCourtEvent rowData={rowData} />
            )}

            {checkSubPermission('file_sharing_non_lawft') && !isClientFileManager && !hideShare && (
              <span role="button" onClick={() => setClientDetailsModalshow(true)}>
                <GlobalTooltip tooltip="Generate Lawft Link" position="top">
                  <i className="bi bi-link-45deg  text-primary-main" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            )}

            {!isClientFileManager && rowData && rowData.esignature_status && rowData.esignature_status.toUpperCase() === 'SIGNED' && (
              <span role="button" onClick={handleDownloadCertificate}>
                <GlobalTooltip tooltip="Download Sign Certificate" className="text-primary-main" position="top">
                  <i className="bi bi-box-arrow-down text-primary-main" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            )}
            {rowData?.file_type && printFileFormats?.includes(rowData?.file_type?.toLowerCase()) ? <PrintFile rowData={rowData} /> : null}
          </>
        )}
        {!isClientFileManager && !hideShare && rowData?.case_id && rowData.case_id !== 'undefined' && (
          <span role="button" onClick={handleShareClick}>
            <GlobalTooltip tooltip="Share" position="top">
              <i className="pi pi-share-alt text-primary-main F-size12" aria-hidden="true" />
            </GlobalTooltip>
          </span>
        )}

        <FileDownload rowData={rowData} onDownloadComplete={onDownloadComplete} />

        {!isClientFileManager ? (
          <MenuIcon item={rowData} index={e.rowIndex} itemsRef={itemsRef} onDownloadComplete={onDownloadComplete} />
        ) : null}
      </span>

      <FileSharingClientDetailsModal
        show={clientDetailsModalshow}
        setShow={setClientDetailsModalshow}
        onHide={() => setClientDetailsModalshow(false)}
        rowData={rowData}
      />
    </React.Fragment>
  );
}

export default ActionsTemplate;
